export function findFormError(o) {
    const entries = Object.entries(o);

    return entries.some(e => {
        if (e[1] === "") return false;

        if (Array.isArray(e[1]) && e[1].length === 0) return false;

        if (typeof e[1] === 'object' && !Array.isArray(e[1]) && e[1] !== null) {
            return findFormError(e[1]);
        }

        return true;
    });
}